import { createFileRoute } from "@tanstack/react-router"
import { Login } from "modules/auth/components/Login"

export const Route = createFileRoute("/_base/_public/login")({
  component: Login,
})
